import { useEffect } from "react";
import { useAutovioContext } from "../hooks/useAutovioContext";
import { useRedirect, useResourceContext } from "react-admin";
import { Box } from "@mui/material";
import { Column } from "./Column";

/**
 * All resources, which can be listed per driving school via /drivingSchools/:id/resource
 * (see DrivingSchoolRoutes.tsx)
 */
export const drivingSchoolResources = [
  "employees",
  "instructors",
  "students",
  "branches",
  "examLocations",
  "otherEventCategories",
  "timetables",
  "courseTemplates",
  "autoForms",
  "rooms",
  "serviceTypes",
  "serviceEntries",
  "customCards",
  "subscriptionPackages",
];

export const vehicleResources = ["cars", "motorcycles", "trailers", "simulators", "trucks", "buses", "tractors"];

export function DefaultList() {
  const resource = useResourceContext();
  const [{ drivingSchoolId }] = useAutovioContext();
  const redirect = useRedirect();
  useEffect(() => {
    if (drivingSchoolId) {
      if (drivingSchoolResources.includes(resource)) {
        redirect(`/drivingSchools/${drivingSchoolId}/${resource}`);
      } else if (resource === "vehicles" || resource === "cars") {
        redirect(`/drivingSchools/${drivingSchoolId}/fleet`);
      } else if (vehicleResources.includes(resource)) {
        redirect(`/drivingSchools/${drivingSchoolId}/fleet#${resource}`);
      }
    }
  }, [drivingSchoolId]);

  if (!drivingSchoolId) {
    return (
      <Box className="centered">
        <Column sx={{ alignItems: "center" }}>Bitte wähle eine Fahrschule aus.</Column>
      </Box>
    );
  }
  return null;
}
